import React from 'react';
import { Button } from 'react-bootstrap';
import FormSectionNew from 'components/sales/formSection/formSectionNew';

const displayText = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return String(value)
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

const displayDate = (value) => {
  if (!value) return '-';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return value;
  return `${match[3]}-${match[2]}-${match[1]}`;
};

const displayAmount = (value) => {
  const amount = Number(value);
  if (Number.isNaN(amount)) return '-';
  return `₹ ${amount.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const DetailField = ({ label, value }) => (
  <div className="handover-preview-fields__item">
    <span className="handover-preview-fields__label">{label}</span>
    <span className="handover-preview-fields__value">{value}</span>
  </div>
);

const HandoverInvoicePreview = ({ data, onConfirm, confirmed }) => {
  const contract = data?.contract || {};
  const handover = data?.handover || {};
  const linkedInvoices = Array.isArray(data?.linked_invoices) ? data.linked_invoices : [];
  const installments = Array.isArray(data?.installments) ? data.installments : [];

  return (
    <div className="handover-preview">
      <FormSectionNew title="Contract Details">
        <div className="handover-preview-fields">
          <DetailField label="Contract Id" value={contract.contract_id ?? '-'} />
          <DetailField label="Service Type" value={displayText(contract.service_type)} />
          <DetailField label="Billing Type" value={displayText(contract.billing_type)} />
          <DetailField label="Payment Cycle" value={displayText(contract.payment_cycle)} />
          <DetailField label="Contract Period" value={contract.contract_period ?? '-'} />
        </div>
      </FormSectionNew>

      <FormSectionNew title="Handover Details">
        <div className="handover-preview-fields">
          <DetailField
            label="Contract Start Date"
            value={displayDate(handover.contract_start_date)}
          />
          <DetailField
            label="Contract End Date"
            value={displayDate(handover.contract_end_date)}
          />
        </div>
      </FormSectionNew>

      {linkedInvoices.length > 0 && (
        <FormSectionNew title="Linked Invoices">
          <div className="handover-preview-table-wrap">
            <table className="table table-bordered handover-preview-table">
              <thead>
                <tr>
                  <th>Invoice Number</th>
                  <th>Invoice Id</th>
                  <th>Invoice Type</th>
                  <th>Billing Start Date</th>
                  <th>Billing End Date</th>
                    <th className="handover-preview-table__amount">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {linkedInvoices.map((row) => (
                  <tr key={row.invoice_id || row.invoice_number}>
                    <td>{row.invoice_number || '-'}</td>
                    <td>{row.invoice_id ?? '-'}</td>
                    <td>{displayText(row.invoice_type)}</td>
                    <td>{displayDate(row.billing_start_date)}</td>
                    <td>{displayDate(row.billing_end_date)}</td>
                    <td className="handover-preview-table__amount">
                      {displayAmount(row.total_amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FormSectionNew>
      )}

      <FormSectionNew title="Installments">
        <div className="handover-preview-table-wrap">
          <table className="table table-bordered handover-preview-table">
            <thead>
              <tr>
                <th className="handover-preview-table__serial">S. No.</th>
                <th>Billing Period</th>
                <th className="handover-preview-table__amount">Principal Amount</th>
              </tr>
            </thead>
            <tbody>
              {installments.length === 0 ? (
                <tr>
                  <td colSpan={3}>No installments</td>
                </tr>
              ) : (
                installments.map((row, index) => (
                  <tr key={row.installment_id || row.installment_number || index}>
                    <td className="handover-preview-table__serial">
                      {row.installment_number ?? index + 1}
                    </td>
                    <td>
                      {displayDate(row.billing_period?.from)} - {displayDate(row.billing_period?.to)}
                    </td>
                    <td className="handover-preview-table__amount">
                      {displayAmount(row.principal_amount)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </FormSectionNew>

      <div className="handover-preview-confirm">
        {confirmed ? (
          <p className="handover-preview-confirm__note">
            Preview confirmed. You can now generate the handover report.
          </p>
        ) : (
          <>
            <p className="handover-preview-confirm__note">
              <span className="text-danger">*</span>

              <b>Review the invoice details and confirm to continue.</b>
            </p>
            <Button
              type="button"
              className="btn btn-primary handover-preview-confirm__btn"
              onClick={onConfirm}
            >
              Confirm
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default HandoverInvoicePreview;
